function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    var secureFlag = window.location.protocol === 'https:' ? ';secure' : '';
    document.cookie = cname + "=" + cvalue + ";path=/;" + expires + secureFlag + ";samesite=Lax";
}

//get value from cookie
function getCookie(cname) {
    if(!document.cookie)
        return ""
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function isValidEmail(address) {
    var pattern = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
    return pattern.test(address);
}

function detectiOSARQuickLook() {
  const testAnchor = document.createElement("a");
  return testAnchor.relList.supports("ar")
}

function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

export {setCookie, getCookie, isValidEmail, detectiOSARQuickLook, getUrlParameter};